import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-csv-instructions',
	templateUrl: './modal-csv-instructions.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class ModalCsvInstructionsComponent implements OnInit {
	private session: Session = inject(Session);
	private dialogRef = inject(MatDialogRef<ModalCsvInstructionsComponent>);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.rows = [{
			firstname: 'Jan',
			lastname: 'Must',
			email: 'jan@msn.com',
			personal_code: 38005015728,
			valid_from: '2021-01-01',
			valid_to: '2022-01-01',
			policy_number: '70-123-233',
			additional_info: 'IT admin',
			additional_info_2: 'Estonia'
		}];
		
		this.vm.canUserManuallyAddInsurance = this.session.canUserManuallyAddInsurance();
		
		this.vm.close = this.close;
	}
	
	close() {
		this.dialogRef.close(undefined);
	}
}